export default "__VITE_ASSET__CwjjyB7P__"